import { IndustryWrapper } from './IndustryModalStyles';
import industrySectormap from '@/data/industrySectormap.json';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Industry from '@/ui/list/industry/Industry';
import { Header, Body, Footer } from '../primaryModalFrame/PrimaryModalFrame.styles';
import { Button } from '@/components/ui/button';

interface IndustryModalProps {
  current?: number;
  apply?: (index: number) => void;
  close?: () => void;
}

const IndustryModal = ({ current, apply, close }: IndustryModalProps) => {
  const { t: newsT } = useTranslation('news');
  const { t: commonT } = useTranslation('common');

  const [_index, set_index] = useState(current);

  const handleApply = () => {
    apply(_index);
    close();
  };

  const language = useSelector((state: any) => state.user.language);
  let index = 0;
  return (
    <>
      <div className="p-6 bg-background-800">
        <div className="text-xl font-medium text-white">{newsT('Select Industry')}</div>
      </div>
      <Body>
        <IndustryWrapper>
          {industrySectormap.map((sector, i) => {
            const length = sector.industry.length;
            const cpIdx = index;
            index += length;
            return (
              <Industry
                key={index}
                idx={cpIdx}
                title={sector[`sectorName_${language}`]}
                industryList={sector.industry}
                selectedIndex={_index}
                onClick={(i) => set_index(i)}
              />
            );
          })}
        </IndustryWrapper>
      </Body>
      <div className="p-4 bg-background-800 flex justify-end">
        <Button className="bg-main px-8 h-10" onClick={handleApply}>
          <div className="text-md font-medium">{commonT('Apply')}</div>
        </Button>
      </div>
    </>
  );
};

export default IndustryModal;
